import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../common/mixins';

const playButtonRules = ({ isLarge, isMobile, theme }) => ({
  cursor: 'pointer',
  height: theme.iconHeight.large,
  margin: `0 ${theme.margin.xlarge}`,
  opacity: theme.opacity.enabled,
  transition: theme.transition.default,
  willChange: 'opacity',
  ':hover': {
    opacity: theme.opacity.hovered,
  },
  extend: [
    {
      condition: isMobile,
      style: {
        opacity: theme.opacity.hovered,
        height: '30px',
        width: '30px',
      },
    },
    {
      condition: !isMobile,
      style: {
        extend: [
          largeScreen({
            height: theme.iconHeight.medium,
            margin: `0 ${theme.margin.xlarge}`,
          }),
          smallScreen({
            height: theme.iconHeight.small,
            margin: `0 ${theme.margin.medium}`,
          }),
          {
            condition: isLarge,
            style: {
              height: '40px',
              width: '40px',
            },
          },
        ],
      },
    },
  ],
});

const PlayButton = ({ isLarge, isMini, isMobile, ...otherProps }) => {
  const { css } = useFela({ isLarge, isMobile });

  return (
    <svg
      className={css(playButtonRules)}
      {...otherProps}
      data-cy="hp-play-button"
    />
  );
};

PlayButton.propTypes = {
  isLarge: PropTypes.bool,
  isMini: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default React.memo(PlayButton);
